export default "__VITE_ASSET__BwjH9biw__"